import React from "react";
import { Helmet } from "react-helmet";

const OpenGraphTag = () => (
  <Helmet>
    <meta property="og:title" content="Feelaxo Salon and Spa" />
    <meta property="og:type" content="website" />
    <meta property="og:image" content="client\src\shared\Logo\logo-red.png" />
    <meta property="og:url" content="https://www.feelaxo.com" />
    <meta property="og:description" content="Book appointments for top-rated salons and spa services near you." />
    <meta property="og:site_name" content="Feelaxo" />
  </Helmet>
);

export default OpenGraphTag;